import { store } from "../store/index";
import {
  filterMermaPart,
  removeMermaPart,
  modifyMermaPart,
  getMermaPartByUuid,
  createMermaPart,
  listMermaPartToExport,
} from "../store/actions/MermaPartActions";

/**
 * Create MermaPart
 */
export const addMermaPart = async (values) => {
  const objSend = { ...values };
  if (objSend.rows.length <= 0) {
    objSend.rows = [];
  }
  const result = await store.dispatch(createMermaPart(objSend));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * Get MermaPart
 */
export const getMermaPart = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(getMermaPartByUuid(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update MermaPart
 */
export const updateMermaPart = async (values, uuid) => {
  const objSend = { ...values };
  if (objSend.rows.length <= 0) {
    objSend.rows = [];
  }
  const result = await store.dispatch(modifyMermaPart(objSend, [uuid]));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * List MermaPart
 */
export const listFilter = async (filter) => {
  let result = await store.dispatch(filterMermaPart(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Delete MermaPart
 */
export const deleteMermaPart = async (uuid) => {
  const result = await store.dispatch(removeMermaPart([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * List order
 */
export const listToExport = async (filter) => {
  const result = await store.dispatch(listMermaPartToExport(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};
